<template>
  <div class="ac-body-container">
    <div class="ac-content-container">
      <div class="header">
        Individual Emails
      </div>
      <div class="sub-header">
        I would like to receive an email for every new:
      </div>
      <SACCheck
        field="criticalAlert"
        :checked="criticalAlert"
        :change="onChange"
        label="Critical Alert"
        subLabel="Water Leak Alert, Frozen Coil Warning"
        :disable="adminRole !== 'admin'"
      />
      <SACCheck
        field="urgentAlert"
        :checked="urgentAlert"
        :change="onChange"
        label="Urgent Alert"
        subLabel="All performance alerts that require immediate attention"
        :disable="adminRole !== 'admin'"
      />
    </div>
    <div class="ac-content-container">
      <div class="header">
        Daily Summary Report
      </div>
      <div class="sub-header">
        Choose when to receive a summary of email
      </div>
      <SACCheck
        field="summary"
        :checked="summary"
        :change="onChange"
        label="I would like to receive a Daily Summary Report of all opportunities (M-F)"
        :disable="adminRole !== 'admin'"
      />
      <div
        v-if="summary"
        class="optional-summary"
      >
        <SACCheck
          field="watchingSummary"
          :checked="watchingSummary"
          :change="onChange"
          label="Include Watching Alerts"
          :disable="adminRole !== 'admin'"
        />
        <div class="lead-summary-time">
          <div class="header">
            Timing Options
          </div>
          <div class="row-container">
            <SACRadio
              name="time"
              field="batchHour"
              value="8"
              :checked="batchHour === '8'"
              :change="onChange"
              label="8 am"
              :disable="adminRole !== 'admin'"
            />
            <SACRadio
              name="time"
              field="batchHour"
              value="12"
              :checked="batchHour === '12'"
              :change="onChange"
              label="Noon"
              :disable="adminRole !== 'admin'"
            />
            <SACRadio
              name="time"
              field="batchHour"
              value="16"
              :checked="batchHour === '16'"
              :change="onChange"
              label="4 pm"
              :disable="adminRole !== 'admin'"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="ac-content-container">
      <div
        v-if="adminRole === 'admin'"
        class="input-container"
      >
        <RecipientSetting
          :recipients="emails"
          :email="email"
          :addEmail="addEmail"
          :removeEmail="removeEmail"
          :onChange="onChange"
          :errorObj="errorObj"
        />
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import SACCheck from '@shared/components/sac/SACCheck.vue';
import SACRadio from '@shared/components/sac/SACRadio.vue';

import emailValidation from '@shared/lib/errorCatch/emailValidation';

import RecipientSetting from './shared/RecipientSetting.vue';

export default {
  name: 'LeadSetting',
  components: {
    RecipientSetting,
    SACCheck,
    SACRadio,
  },
  mixins: [partnerSettingsMixin],
  props: {
    criticalAlert: Boolean,
    urgentAlert: Boolean,
    watchingAlert: Boolean,
    summary: Boolean,
    watchingSummary: Boolean,
    batchHour: String,
    email: String,
    emails: Array,
    onChange: Function,
    addEmail: Function,
    removeEmail: Function,
    changeCheck: Boolean,
    errorObj: Object,
  },
  methods: {
    isValidEmail() {
      if (this.email) {
        return emailValidation(this.email) && !this.emails.includes(this.email);
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>

.input-container {
  width: 60%;
}
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}
.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}
.optional-summary {
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 50px;
  .lead-summary-time {
    border-radius: 6px;
    margin-top: 20px;
    border: 2px solid $N20;
    padding: 5px;
    .row-container {
      display: grid;
      grid-auto-flow: column;
      gap: 20px;
    }
  }
}
.ac-content-container {
  &:not(:last-child) {
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-bottom: 2px solid $N20;
  }
}
.error-text {
  color: $TOMATO100 !important;
  font-size: 0.875rem;
  font-weight: 500;
  padding-left: 4px;
  margin-top: 5px;
}
</style>
